<template>
  <div class="create-task-container">
    <v-row>
      <v-col :cols="12" :lg="8" class="task-form">
        <v-row>
          <!-- Task Name -->
          <v-col cols="12">
            <input
              readonly
              v-model="EditTaskStore.title"
              :class="[
                'calender-input calender-input-lg w-100',
                EditTaskStore?.errors?.title?.length > 0 ? 'border-error' : '',
              ]"
              placeholder="Task Name"
            />
          </v-col>

          <!-- Task Sub Components -->
          <TaskStatus />
          <TaskTags />
          <TaskDates />
          <TaskPriority />
          <TaskAssignee />
          <TaskDescription />
          <TaskPostType />
          <TaskPlatforms />
          <TaskBranch />
          <TaskCaption />
          <TaskAttachments />
          <TaskPostReview />
        </v-row>
      </v-col>

      <v-col :cols="12" :lg="4" class="task-activity">
        <TaskActivity />
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { useEditTaskStore } from "@/store/editTaskStore";

// Components
import TaskStatus from "./TaskStatus.vue";
import TaskTags from "./TaskTags.vue";
import TaskDates from "./TaskDates.vue";
import TaskPriority from "./TaskPriority.vue";
import TaskAssignee from "./TaskAssignee.vue";
import TaskDescription from "./TaskDescription.vue";
import TaskPostType from "./TaskPostType.vue";
import TaskPlatforms from "./TaskPlatforms.vue";
import TaskBranch from "./TaskBranch.vue";
import TaskCaption from "./TaskCaption.vue";
import TaskAttachments from "./TaskAttachments.vue";
import TaskPostReview from "./TaskPostReview.vue";
import TaskActivity from "./TaskActivity.vue";

// Store + Router
const EditTaskStore = useEditTaskStore();
const route = useRoute();

// Fully Synced Load
onMounted(async () => {
  await EditTaskStore.loadFullTask(route.params.id);
});
</script>
